import styled from 'styled-components';

import { Button } from '../../../Toolkit/Button';
import { donedealBreakpoints } from 'styled-system';

export const YourDetailsSection = styled.div`
  margin-top: ${({ theme }) => theme.spacing.M16};

  ${donedealBreakpoints.media.medium} {
    margin-top: ${({ theme }) => theme.spacing.M24};
  }
`;

export const ConsentAndActionRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.M24};
  margin-top: ${({ theme }) => theme.spacing.M24};

  ${donedealBreakpoints.media.medium} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    margin-top: ${({ theme }) => theme.spacing.M32};
    gap: ${({ theme }) => theme.spacing.L40};
  }
`;

export const ContinueButton = styled(Button)`
  width: 100%;
  height: 48px;
`;

export const PrivacyLink = styled.a`
  color: inherit;
  text-decoration: underline;
`;
